export const MailParser = function (rawMessage) {
    var cc, explodeMessage, from, getValidStr, messageParts, rawHeaders, subject, to;
    explodeMessage = function (inMessage) {
        var escBoundary, i, inBody, inBodyParts, inBoundary, inContentType, inContentTypeParts, inHeaderPos, inRawBody, inRawHeaders, match, mimeType, mimeTypeParts, regContentType, regString, specialChars;
        inHeaderPos = inMessage.indexOf("\r\n\r\n");
        if (inHeaderPos === -1) {
            inMessage = inMessage.replace(/\n/g, "\r\n");
            inHeaderPos = inMessage.indexOf("\r\n\r\n");
            if (inHeaderPos === -1) {
                inHeaderPos = inMessage.length;
            }
        }
        inRawHeaders = inMessage.slice(0, inHeaderPos).replace(/\r\n\s+/g, " ") + "\r\n";
        inRawBody = inMessage.slice(inHeaderPos).replace(/(\r\n)+$/, "").replace(/^(\r\n)+/, "");
        inContentType = "";
        regContentType = inRawHeaders.match(/Content-Type: (.*)/i);
        if (regContentType && regContentType.length > 0) {
            inContentType = regContentType[1];
        } else {
            console.log("Warning: MailParser: Content-type doesn't exist!");
        }
        inContentTypeParts = inContentType.split(";");
        mimeType = inContentTypeParts[0].replace(/\s/g, "");
        mimeTypeParts = mimeType.split("/");
        if (mimeTypeParts[0].toLowerCase() === "multipart") {
            inBodyParts = [];
            match = inContentTypeParts[1].match(/boundary="?([^"]*)"?/i);
            if (!match && inContentTypeParts[2]) {
                match = inContentTypeParts[2].match(/boundary="?([^"]*)"?/i);
            }
            inBoundary = _util.trim(match[1]).replace(/"/g, "");
            escBoundary = inBoundary.replace(/\+/g, "\\+");
            regString = new RegExp("--" + escBoundary, "g");
            inBodyParts = inRawBody.replace(regString, inBoundary).replace(regString, inBoundary).split(inBoundary);
            inBodyParts.shift();
            inBodyParts.pop();
            i = 0;
            while (i < inBodyParts.length) {
                inBodyParts[i] = inBodyParts[i].replace(/(\r\n)+$/, "").replace(/^(\r\n)+/, "");
                inBodyParts[i] = explodeMessage(inBodyParts[i]);
                i++;
            }
        } else {
            inBody = inRawBody;
            if (mimeTypeParts[0] === "text") {
                inBody = inBody.replace(RegExp("=\\r\\n", "g"), "");
                specialChars = inBody.match(RegExp("=[A-F0-9][A-F0-9]", "g"));
                if (specialChars) {
                    i = 0;
                    while (i < specialChars.length) {
                        inBody = inBody.replace(specialChars[i], String.fromCharCode(parseInt(specialChars[i].replace(RegExp("="), ""), 16)));
                        i++;
                    }
                }
            }
        }
        return {
            rawHeaders: inRawHeaders,
            rawBody: inRawBody,
            body: inBody,
            contentType: inContentType,
            contentTypeParts: inContentTypeParts,
            boundary: inBoundary,
            bodyParts: inBodyParts,
            mimeType: mimeType,
            mimeTypeParts: mimeTypeParts
        };
    };
    messageParts = "";
    try {
        messageParts = explodeMessage(rawMessage);
    } catch (_error) { }
    rawHeaders = messageParts.rawHeaders;
    getValidStr = function (arr) {
        if (arr == null) {
            arr = [];
        }
        return arr[1] || "";
    };
    subject = getValidStr(/\r\nSubject: (.*)\r\n/g.exec(rawHeaders));
    to = getValidStr(/\r\nTo: (.*)\r\n/g.exec(rawHeaders));
    cc = getValidStr(/\r\nCc: (.*)\r\n/g.exec(rawHeaders));
    from = getValidStr(/\r\nFrom: (.*)\r\n/g.exec(rawHeaders));
    return {
        messageParts: messageParts,
        subject: subject,
        to: to,
        cc: cc,
        from: from
    };
};
